import React from 'react';
import {
  AquistaButton,
  AquistaButtonsContainer,
  LeftCol,
  LogoContainer,
  LogoPriceContainer,
  Price,
  PriceContainer,
  QuotationCardStyles,
  QuoteInformationContainer,
  QuoteInformationItem,
  RightCol,
  SavedButton,
} from '../ResultPageComponents/v2/QuotationCard.styles';
import { BACKEND_BASE_URL } from '../../../../config';

function GlobalAssistanceCard(props) {
  const {
    quotation,
    requestInfo,
    selectQuotation,
  } = props;
  return (
    <QuotationCardStyles className={quotation.is_aquista === 1 ? 'selected' : ''}>
      <LeftCol>
        <div>
          <LogoPriceContainer>
            <LogoContainer>
              <img src={BACKEND_BASE_URL + quotation.company.logo} alt={`${quotation.company.name} Logo`} />
            </LogoContainer>
            <PriceContainer>
              <Price>
                <h5>Prezzo annuo:</h5>
                <h2>
                  {Number(quotation.amount).toLocaleString('it-IT', {
                    minimumFractionDigits: 2,
                  })}
                  €
                </h2>
              </Price>
            </PriceContainer>
          </LogoPriceContainer>
        </div>
      </LeftCol>
      <RightCol>
        <div>
          <QuoteInformationContainer>
            <QuoteInformationItem>
              <h6>Compagnia:</h6>
              <p>Global Assistance</p>
            </QuoteInformationItem>
            <QuoteInformationItem>
              <h6>Emissione:</h6>
              <p>Tradizionale</p>
            </QuoteInformationItem>
            <QuoteInformationItem>
              <h6>Frequenza pagamento:</h6>
              <p>{quotation.payment_frequency === 1 ? 'Annuo' : 'Semestrale'}</p>
            </QuoteInformationItem>
            <QuoteInformationItem>
              <h6>Prodotto:</h6>
              <p>{quotation.product_name}</p>
            </QuoteInformationItem>
            {quotation.massimale != 0 && (
              <QuoteInformationItem>
                <h6>Pagamento massimale:</h6>
                <p>
                  {new Intl.NumberFormat().format(quotation.massimale)}
                  €
                </p>
              </QuoteInformationItem>
            )}
          </QuoteInformationContainer>
        </div>
        {selectQuotation && (
          <AquistaButtonsContainer>
            {requestInfo.processing_quotation_id !== quotation.id ? (
              <AquistaButton
                onClick={() => selectQuotation(quotation.id)}
                className="purchase-quote-nine-step"
              >
                Seleziona
              </AquistaButton>
            ) : requestInfo.processing_quotation_id === quotation.id && <SavedButton>Aggiunto</SavedButton>}
          </AquistaButtonsContainer>
        )}
      </RightCol>
    </QuotationCardStyles>
  );
}

export default GlobalAssistanceCard;
